import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const EmailConstructorLazy = loadable(
    () => import(/* webpackChunkName: "EmailConstructor" */ './EmailConstructorSuspense')
);

export const EmailConstructorAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <EmailConstructorLazy />
    </DelayedSuspense>
);
